import { matchMedium } from '../../application/utils/breakpoints'
import { createSwiper, destroySwiper } from './category-swiper'
import './category-preview.component.scss'
const matchInstance = matchMedium()

const swiperElements = []
document.querySelectorAll('.category-preview').forEach((root) => {
  const swiperElement = root.querySelector('.swiper-container')
  if (swiperElement) {
    swiperElements.push(swiperElement)
  }
})

function toggleState(matches) {
  if (matches) {
    swiperElements.forEach(createSwiper)
  } else {
    swiperElements.forEach(destroySwiper)
  }
}

if (swiperElements.length > 0) {
  toggleState(matchInstance.matches)
  matchInstance.subcribe(toggleState)
}
